/* ErrorState — shown when a fetch fails. Includes a retry button. */
import React from "react";
import { P, FC } from "../../shared/constants";
import { AlertTriangle, Refresh } from "../icons";
var E = React.createElement;

export default function ErrorState(props){
  return E("div", {
    role:"alert",
    style:{padding:"24px 20px",textAlign:"center",borderRadius:12,
      background:P.coralLt,border:"1.5px solid "+P.coral+"40"}
  },
    E("div",{"aria-hidden":"true",style:{marginBottom:8,display:"flex",justifyContent:"center",color:P.coral}},
      E(AlertTriangle,{size:24})),
    E("div",{style:{fontSize:14,fontWeight:700,color:P.coral,marginBottom:6}},
      props.title || "We couldn't load this."),
    props.message ? E("div",{style:{fontSize:11,color:P.slateM,marginBottom:14,
      fontFamily:FC,wordBreak:"break-word"}}, props.message) : null,
    props.onRetry ? E("button",{type:"button",onClick:props.onRetry,
      style:{padding:"8px 16px",borderRadius:8,border:"none",background:P.pri,
        color:"#fff",fontSize:11,fontWeight:700,minHeight:36,cursor:"pointer",
        display:"inline-flex",alignItems:"center",gap:6}},
      E(Refresh,{size:14}), "Try again") : null
  );
}
